import styled, { css } from 'styled-components';
import {
  getSpace,
  getTextType,
  getGridSpans,
  mq,
  getColor,
  setGridColumns,
  gridContainer
} from '../../../stylesheets/tools';

const footerImage = '/static/dots/footer-background.svg';

const StyledFooter = styled.footer`
  position: relative;
  margin-top: ${getSpace('xl')};

  &.isArchivePage {
    margin-top: 0;

    .footer__sub {
      > div {
        margin-right: 0;
      }

      .footer__sub-navigation {
        position: relative;

        ${mq('l')} {
          border-right: none;

          &:after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            height: 14px;
            width: 2px;
            background-color: ${getColor('black')};
          }
        }
      }
    }
  }

  ${props =>
    props.noDots &&
    css`
      margin-top: 0;
      // background: #000;

      .footer__wrapper {
        padding-top: ${getSpace('xxxl')};
      }
    `}

    ${props =>
      !props.noDots &&
      css`
        .footer__dots {
          position: relative;
          width: 100%;
          height: 436px;
          background-image: url(${footerImage});
          background-size: 592px 436px;
          background-repeat: repeat;
          margin-bottom: -5px;
        }
      `}

  .footer__wrapper {
    background: #000;
    color: #fff;

    svg.futurium__logo {
      width: 220px;
      height: 24px;

      ${mq('s')} {
        width: 318px;
        height: 35px;
      }
    }

    a {
      color: #fff;

      &:hover, &:focus {
        color: ${props => props.theme.globalTheme.contrastCta}
      }
    }
  }

  .footer__content {
    padding: 0 0 ${getSpace('xl')};
    margin-top: ${getSpace('xl')};
  }

  .footer__currentInfo {
    ${getGridSpans('width', { s: 12, m: 6, l: 5 })}
    ${getGridSpans('margin-left', { m: 0, l: [1, 'spread'] })}
    margin-top: ${getSpace('l')};

    ${mq('m')} {
      margin-top: 0;
    }
  }

  .footer__navigation {
    margin-top: ${getSpace('xs')};
    
    ul {
      ${gridContainer()}
      ${setGridColumns('1fr', 1)}
      gap: 10px;
      
      ${mq('m')} {
        gap: 15px;
        ${setGridColumns('1fr', 2)}
      }
      ${mq('l')} {
        ${setGridColumns('1fr', 3)}
      }
      ${mq('xl')} {
        ${setGridColumns('1fr', 5)}
      }
      padding: 0;
    }

    li {
      ${getTextType('tertiary')};
      display: block;
      margin: 0 0 ${getSpace('xs')};
      text-transform: uppercase;

      ${mq('m')} {
        ${getTextType('subline')};
        margin: 0 0 ${getSpace('xxs')};
        
        a {
          font-size: 22px;
        }
      }  
    }
  }

  .footer__sub {
    background: transparent;
    color: #000;
    padding: ${getSpace('s')} 0;
    text-transform: uppercase;

    ${mq('l')} {
      .container__wrapper {
        display: flex;
        align-items: center;
      }
    }

    svg {
      margin-right: ${getSpace('s')};
    }
  }
  .footer__sub-navigation {
    border-bottom: 1px solid lightgray;
    margin: ${getSpace('m')} 0;

    ${mq('l')} {
      margin: 0;
      padding-right: ${getSpace('m')};
      margin-right: ${getSpace('m')};
      border-right: 1px solid lightgray;
      border-bottom: none;
      flex-grow: 2;
      text-align: right;
    }

    ul {
      padding: 0;
    }

    li {
      margin: ${getSpace('s')} 0;

      ${mq('l')} {
        display: inline-block;
        margin: 0;
      }
    }

    li + li {
      ${mq('l')} {
        margin-left: ${getSpace('s')};
      }
    }

    a[role='button'] {
      cursor: pointer;
    }

    a:hover, a:focus {
       text-decoration: underline;
    }
  }
  @media print {
    display: none;
  }
`;

export default StyledFooter;
